/**
 * @file positionSticky.js
 */

import Stickyfill from 'stickyfilljs'; // https://www.npmjs.com/package/stickyfilljs

/**
 * position: stickyのpolyfill
 */
const elements = document.querySelectorAll('.js-stickyfill');
Stickyfill.add(elements);
